import { useState, useEffect } from 'react';

function useDebounce(value: string, delay: number): string {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler); // Clean up the timeout on value or delay change
        };
    }, [value, delay]);

    return debouncedValue;
}

export default useDebounce;
